import { ICON_BASE_PATH, IMAGE_BASE_PATH } from "@/app/utils/config";
import { useContactSupportLookup } from "@/app/hooks/useContactSupportLookup";

interface ContactSupportContentProps {
  variant?: "modal" | "inline";
  title?: string;
  onClose?: () => void;
}

export const ContactSupportContent = ({
  variant = "modal",
  title = "Hello, How can we help you?",
}: ContactSupportContentProps) => {
  const { data, loading, error, refetch } = useContactSupportLookup();

  const countryCode =
    data.find((item) => item.gxLookupCode === "Country code")?.gxLookupValue ??
    "";
  const mobileNo =
    data.find((item) => item.gxLookupCode === "Mobile No")?.gxLookupValue ?? "";
  const emailId =
    data.find((item) => item.gxLookupCode === "Email id")?.gxLookupValue ?? "";

  const phoneNumber = [countryCode, mobileNo].filter(Boolean).join(" ");
  const telHref = [countryCode, mobileNo]
    .filter(Boolean)
    .join("")
    .replace(/\s+/g, "");

  if (loading) {
    return (
      <div className="support-container">
        <p className="gx-support__status">Loading contact details…</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="support-container">
        <div className="gx-support__status gx-support__status--error">
          <p>{error}</p>
          <button className="gx-support__retry" onClick={refetch}>
            Retry
          </button>
        </div>
      </div>
    );
  }

  // ---------- MODAL VARIANT (matches "Contact Us" popup) ----------
  if (variant === "modal") {
    return (
      <>
        <div className="support-container">
          <div className="support-icon">
            <img
              src={`${IMAGE_BASE_PATH}support.svg`}
              alt="DemoBank Logo"
              className="app-logo"
            />
          </div>

          <h2 className="support-title">{title}</h2>

          {loading && (
            <p className="support-status">Loading support details…</p>
          )}

          {!loading && error && (
            <div className="support-status support-status--error">
              <p>{error}</p>
              <button className="support-retry-btn" onClick={refetch}>
                Retry
              </button>
            </div>
          )}

          {!loading && !error && (
            <div className="support-options">
              {phoneNumber && (
                <a
                  href={`tel:${telHref}`}
                  className="support-card support-card--link"
                >
                  <div className="support-card-icon">
                    <img
                      src={`${ICON_BASE_PATH}callus.svg`}
                      alt="call Logo"
                      className="app-logo"
                    />
                  </div>
                  <div>
                    <p className="support-label">Call Us</p>
                    <p className="support-value">{phoneNumber}</p>
                  </div>
                </a>
              )}

              {emailId && (
                <a
                  href={`mailto:${emailId}`}
                  className="support-card support-card--link"
                >
                  <div className="support-card-icon">
                    <img
                      src={`${ICON_BASE_PATH}email.svg`}
                      alt="email Logo"
                      className="app-logo"
                    />
                  </div>
                  <div>
                    <p className="support-label">Send us an E-mail</p>
                    <p className="support-value">{emailId}</p>
                  </div>
                </a>
              )}
            </div>
          )}
        </div>
      </>
    );
  }

  return (
    <div className="gx-email-container">
      <h3 className="gx-h4-sb">Contact GrowX Global support </h3>

      {emailId && (
        <a href={`mailto:${emailId}`}>
          <div className="gx-support__inline-rows">
            <img src={`${ICON_BASE_PATH}email.svg`} alt="" />
            <span className="gx-p12-m">{emailId}</span>
          </div>
        </a>
      )}
      {phoneNumber && (
        <a href={`tel:${telHref}`}>
          <div className="gx-support__inline-rows">
            <img src={`${ICON_BASE_PATH}callus.svg`} alt="" />
            <span className="gx-p12-m">{phoneNumber}</span>
          </div>
        </a>
      )}
    </div>
  );
};
